module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid h100",
    staticStyle: {
      "grid-template-columns": "auto 1fr"
    }
  }, [_c('navbar', {
    attrs: {
      "hotel": _vm.hotel,
      "settings": _vm.settings,
      "ombrelli": _vm.ombrelli,
      "addpool": _vm.addpool,
      "addombrid": _vm.addombrid,
      "addombrell": _vm.addombrell,
      "editpool": _vm.editpool,
      "edit": _vm.edit
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "grid",
      "justify-content": "center",
      "overflow-y": "auto",
      "height": "100vh",
      "padding": "96px 0"
    }
  }, [(!_vm.loading) ? _c('div', {}, [_vm._l((_vm.hotel.pools), function(pool, index) {
    return _c('VueDragResize', {
      key: pool._id,
      staticClass: "pool grid",
      staticStyle: {
        "align-content": "center",
        "justify-content": "center"
      },
      attrs: {
        "snapToGrid": true,
        "gridX": 200,
        "gridY": 200,
        "isActive": _vm.edit,
        "x": pool.x,
        "y": pool.y,
        "w": pool.width,
        "h": pool.height,
        "z": 997,
        "isDraggable": _vm.edit,
        "isResizable": _vm.edit
      },
      on: {
        "resizing": function (left, top, width, height) { return _vm.pooldrag(index, left, top, width, height); },
        "dragstop": function (left, top, width, height) { return _vm.pooldrag(index, left, top, width, height); }
      }
    }, [(_vm.edit) ? _c('a', {
      staticClass: "btn",
      staticStyle: {
        "z-index": "999"
      },
      on: {
        "click": function($event) {
          return _vm.removePool(index)
        }
      }
    }, [_vm._v("remove")]) : _vm._e(), _vm._v(" "), (!_vm.edit) ? _c('span', {
      staticClass: "fas fa-swimming-pool",
      style: ({
        fontSize: pool.width / 8 + 'px'
      })
    }) : _vm._e()])
  }), _vm._v(" "), _vm._l((_vm.ombrelli), function(ombrello, index) {
    return _c('VueDragResize', {
      key: ombrello._id,
      staticClass: "blocco ombrello",
      attrs: {
        "snapToGrid": true,
        "gridX": 20,
        "gridY": 20,
        "isActive": _vm.edit,
        "x": ombrello.x,
        "y": ombrello.y,
        "w": ombrello.width,
        "h": ombrello.height,
        "z": 997,
        "isDraggable": _vm.edit,
        "isResizable": false
      },
      on: {
        "resizing": _vm.resize,
        "dragstop": function (left, top, width, height) { return _vm.onResizing(index, left, top, width, height); }
      }
    }, [(!ombrello.free && ombrello.location === 'pool') ? _c('div', {
      staticClass: "blocco seat"
    }, [(_vm.hotel.poolsettings.beds || _vm.hotel.poolsettings.chairs) ? _c('div', {
      staticClass: "header blocco row"
    }, [(_vm.hotel.poolsettings.chairs) ? _c('div', {
      staticClass: "blocco"
    }, [_c('img', {
      attrs: {
        "src": require("../assets/img/beach-deckchair-.png")
      }
    }), _vm._v(" "), _c('span', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.removechair(index, ombrello.chairs, ombrello._id, _vm.hotelid)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-minus-square"
    })]), _vm._v(_vm._s(ombrello.chairs)), _c('a', {
      on: {
        "click": function($event) {
          return _vm.addchair(index, ombrello.chairs, ombrello._id, _vm.hotelid)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-plus-square"
    })])])]) : _vm._e(), _vm._v(" "), (_vm.hotel.poolsettings.beds) ? _c('div', {
      staticClass: "blocco"
    }, [_c('img', {
      attrs: {
        "src": require("../assets/img/beach-chair.png")
      }
    }), _vm._v(" "), _c('span', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.removebed(index, ombrello.beds, ombrello._id, _vm.hotelid)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-minus-square"
    })]), _vm._v(_vm._s(ombrello.beds)), _c('a', {
      on: {
        "click": function($event) {
          return _vm.addbed(index, ombrello.beds, ombrello._id, _vm.hotelid)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-plus-square"
    })])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "ident blocco row"
    }, [(_vm.hotel.poolsettings.room) ? _c('span', {
      staticClass: "room"
    }, [_vm._v(_vm._s(ombrello.room))]) : _vm._e(), _vm._v(" "), (ombrello.guest) ? _c('span', {
      on: {
        "click": function($event) {
          return _vm.show(ombrello)
        }
      }
    }, [_vm._v(_vm._s(ombrello.guest))]) : _vm._e(), _vm._v(" "), (!ombrello.guest) ? _c('span', {
      on: {
        "click": function($event) {
          return _vm.show(ombrello)
        }
      }
    }, [_vm._v("no guest")]) : _vm._e()]), _vm._v(" "), (_vm.hotel.poolsettings.arrival || _vm.hotel.poolsettings.departure || _vm.hotel.poolsettings.ombrid) ? _c('div', {
      staticClass: "caldata blocco row"
    }, [(_vm.hotel.poolsettings.ombrid) ? _c('div', {
      staticClass: "blocco nr"
    }, [_vm._v(_vm._s(ombrello.ombrid))]) : _vm._e(), _vm._v(" "), (_vm.hotel.poolsettings.arrival || _vm.hotel.poolsettings.departure) ? _c('div', {
      staticClass: "blocco"
    }, [(_vm.hotel.poolsettings.arrival) ? _c('span', [_c('span', {
      staticClass: "fa fa-chevron-right"
    }), _vm._v(" " + _vm._s(ombrello.arrival))]) : _vm._e(), _vm._v(" "), (_vm.hotel.poolsettings.departure) ? _c('span', [_c('span', {
      staticClass: "fa fa-chevron-left"
    }), _vm._v(" " + _vm._s(ombrello.departure))]) : _vm._e()]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (ombrello.free && ombrello.location === 'pool') ? _c('div', {
      staticClass: "blocco seat free drop",
      attrs: {
        "id": ombrello._id
      }
    }, [_c('div', {
      staticClass: "blocco nr",
      attrs: {
        "id": ombrello._id
      },
      on: {
        "click": function($event) {
          return _vm.show(ombrello)
        }
      }
    }, [_vm._v(_vm._s(ombrello.ombrid))])]) : _vm._e()])
  })], 2) : _vm._e()]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "hello-world",
      "width": "50%",
      "height": "50%",
      "adaptive": true
    }
  }, [_c('div', {
    staticClass: "grid edit w100"
  }, [_c('div', {
    staticClass: "grid data h50"
  }, [(!_vm.editombrid) ? _c('h1', {
    on: {
      "click": _vm.changeombrid
    }
  }, [_vm._v(_vm._s(_vm.ombrellos.ombrid))]) : _vm._e(), _vm._v(" "), (_vm.editombrid) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ombrellos.ombrid),
      expression: "ombrellos.ombrid"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "ombrid"
    },
    domProps: {
      "value": (_vm.ombrellos.ombrid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ombrellos, "ombrid", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Guest Name")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ombrellos.guest),
      expression: "ombrellos.guest"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "guest"
    },
    domProps: {
      "value": (_vm.ombrellos.guest)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ombrellos, "guest", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ombrellos.room),
      expression: "ombrellos.room"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "room",
      "placeholder": "Room Number"
    },
    domProps: {
      "value": (_vm.ombrellos.room)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ombrellos, "room", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Arrival and Departure")])]), _vm._v(" "), _c('DateRange', {
    staticClass: "calendar",
    attrs: {
      "sync-range": _vm.range,
      "first-day-of-week": 1,
      "lang": _vm.lang
    },
    on: {
      "update:syncRange": function($event) {
        _vm.range = $event
      },
      "update:sync-range": function($event) {
        _vm.range = $event
      },
      "change": _vm.onChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: " spacer md"
  }), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "btn btn-green",
    on: {
      "click": _vm.updateombrello
    }
  }, [_vm._v("Update Umbrella")])]), _vm._v(" "), _c('div', {
    staticClass: " spacer md"
  }), _vm._v(" "), _c('p', [(!_vm.ombrellos.free) ? _c('a', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.closeombrello
    }
  }, [_vm._v("close ombrello")]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "grid seats h50",
    class: {
      free: _vm.ombrellos.free
    }
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/beach-deckchair-@2x.png")
    }
  }), _vm._v(" "), _c('span', [_c('a', {
    on: {
      "click": function($event) {
        _vm.ombrellos.chairs -= 1
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-minus-square"
  })]), _vm._v(_vm._s(_vm.ombrellos.chairs)), _c('a', {
    on: {
      "click": function($event) {
        _vm.ombrellos.chairs += 1
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus-square"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/beach-chair@2x.png")
    }
  }), _vm._v(" "), _c('span', [_c('a', {
    on: {
      "click": function($event) {
        _vm.ombrellos.beds -= 1
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-minus-square"
  })]), _vm._v(_vm._s(_vm.ombrellos.beds)), _c('a', {
    on: {
      "click": function($event) {
        _vm.ombrellos.beds += 1
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus-square"
  })])])])])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "settings",
      "width": "50%",
      "height": "50%",
      "adaptive": true
    }
  }, [_c('div', {
    staticClass: "grid edit w100"
  }, [_c('div', {
    staticClass: "grid data h50"
  }, [_c('h1', [_vm._v(_vm._s(_vm.hotel.hotelname))]), _vm._v(" "), _c('label', [_vm._v("cols")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hotel.cols),
      expression: "hotel.cols"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "cols"
    },
    domProps: {
      "value": (_vm.hotel.cols)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.hotel, "cols", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("rows")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hotel.rows),
      expression: "hotel.rows"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "rows"
    },
    domProps: {
      "value": (_vm.hotel.rows)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.hotel, "rows", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("lang")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hotel.lang),
      expression: "hotel.lang"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "lang"
    },
    domProps: {
      "value": (_vm.hotel.lang)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.hotel, "lang", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: " spacer md"
  }), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "btn btn-green",
    on: {
      "click": _vm.updatehotel
    }
  }, [_vm._v("Update Settings")])]), _vm._v(" "), _c('div', {
    staticClass: " spacer md"
  })]), _vm._v(" "), _c('div', {
    staticClass: "grid seats h50"
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/beach-deckchair-@2x.png")
    }
  }), _vm._v(" "), _c('span', [_c('a', {
    on: {
      "click": function($event) {
        _vm.hotel.chairs -= 1
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-minus-square"
  })]), _vm._v(_vm._s(_vm.hotel.chairs)), _c('a', {
    on: {
      "click": function($event) {
        _vm.hotel.chairs += 1
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus-square"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/beach-chair@2x.png")
    }
  }), _vm._v(" "), _c('span', [_c('a', {
    on: {
      "click": function($event) {
        _vm.hotel.beds -= 1
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-minus-square"
  })]), _vm._v(_vm._s(_vm.hotel.beds)), _c('a', {
    on: {
      "click": function($event) {
        _vm.hotel.beds += 1
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus-square"
  })])])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74da0a63","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pool.vue
// module id = 653
// module chunks = 1